'use client'

import { AdBannerScheduleType } from '@/app/types/adType'
import { ProductSearchResponse } from '@/app/types/productSearchType'
import ProductFilter from '../(Filters)/ProductFilter/ProductFilter'
import ProductPageHeader from './(components)/ProductPageHeader'
import ProductsList from './ProductsList'

export const ProductPage = ({
  adList,
  productData,
  isLoading,
}: {
  adList?: AdBannerScheduleType[]
  productData: ProductSearchResponse
  isLoading: boolean
}) => {
  return (
    <div className="flex flex-row gap-7 mobile:flex-col">
      <div className="mobile:hidden">
        <ProductFilter />
      </div>
      <div className="w-[627px] mobile-width">
        <ProductPageHeader />
        <ProductsList
          adList={adList}
          productData={productData}
          isLoading={isLoading}
        />
      </div>
    </div>
  )
}

export default ProductPage
